var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.32451 27.895C4.2879 27.8891 4.16809 27.8704 4.05826 27.8533C3.80326 27.8138 3.41215 27.6821 3.1397 27.5441C2.1191 27.0273 1.38308 25.9976 1.17901 24.801C1.12523 24.4857 1.12523 9.61393 1.17901 9.2986C1.44499 7.739 2.5904 6.52201 4.05826 6.23939C4.35504 6.18225 18.352 6.18225 18.6488 6.23939C19.9386 6.48773 20.9944 7.46071 21.4012 8.77595C21.5629 9.29875 21.5589 9.23102 21.57 11.6367C21.5754 12.8069 21.5612 12.1311 21.5537 13.88C23.2154 12.6328 22.2911 13.3207 24.6527 11.5803C25.4142 11.0192 27.156 9.73478 28.5234 8.72603C29.8909 7.71727 31.0141 6.89666 31.0196 6.90245C31.025 6.90823 31.0265 11.4725 31.0228 17.0453C31.0188 22.9902 31.0217 23.3332 31.023 27.198C29.2379 25.8838 29.1103 25.7814 27.7678 24.7979C25.9813 23.489 23.8636 21.9359 23.0618 21.3465C22.26 20.757 21.5986 20.2748 21.5921 20.2748C21.5856 20.2748 21.5756 21.2645 21.57 22.4742C21.5589 24.8674 21.5628 24.8012 21.4012 25.3237C21.0491 26.4619 20.2119 27.3514 19.1407 27.7255C18.6113 27.9103 19.2563 27.8956 11.46 27.9008C7.57208 27.9034 4.36112 27.9008 4.32451 27.895Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_13",
    x: 0,
    y: 0,
    width: 42.3,
    height: 46.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_13",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/VideoCamera.bcd2021d16aeab72e5b2789e5450ce2c.svg";
export { ForwardRef as ReactComponent };